import React from 'react';
import { Container, Heading } from '@charlietango/ui';
import { rem } from '../../styles/rem';

import Arrow from '../../components/Arrow/Arrow';
import Button from '../../components/Button/Button';
import RichText from '../../components/RichText/RichText';
import { ButtonVariant } from '../../styles/buttons';
import { TextVariant } from '../../styles/typography';
import LinkViewModel from '../../view-models/LinkViewModel';

export type NotFoundProps = {
  link?: LinkViewModel;
  title?: string;
  text?: string;
};

function NotFound({ title, text, link }: NotFoundProps) {
  return (
    <Container
      sx={{
        maxWidth: '40rem',
        textAlign: 'center',
        mt: [rem(128), rem(248)],
        mb: [rem(128), rem(248)],
      }}
    >
      {title && (
        <Heading as="h1" variant={TextVariant.Header2xl}>
          {title}
        </Heading>
      )}
      {text && (
        <RichText sx={{ mb: 8 }} variant={TextVariant.BodyLg}>
          {text}
        </RichText>
      )}
      {link && (
        <Button
          {...link}
          prefetch
          variant={ButtonVariant.Flat}
          sx={{
            pr: 8,
            width: 'auto',
          }}
          icon={<Arrow sx={{ height: '1em', ml: 4, mt: '-2px' }} />}
        >
          {link.label}
        </Button>
      )}
    </Container>
  );
}

NotFound.displayName = 'NotFound';

export default NotFound;
